document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('[data-hacon-web-app-url]').forEach(haconWebAppTarget => {
		try {
			let updatedIframeURL = new URL(haconWebAppTarget.getAttribute('data-hacon-web-app-url'));
			updatedIframeURL.search = window.location.search
			haconWebAppTarget.querySelector('iframe').src = updatedIframeURL.toString();
		} catch (e) {
			console.error(e)
		}
	});
});
